'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainMenuContent = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp, _dec2, _class3, _dec3, _class4, _class5, _temp2, _dec4, _class6, _class7, _temp3;

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _reduxRouter = require('redux-router');

var _info = require('redux/modules/info');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MainMenuLink: {
    displayName: 'MainMenuLink'
  },
  Settings: {
    displayName: 'Settings'
  },
  MainMenuSettingsButton: {
    displayName: 'MainMenuSettingsButton'
  },
  MainMenuContent: {
    displayName: 'MainMenuContent'
  },
  MainMenu: {
    displayName: 'MainMenu'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/MainMenu/MainMenu.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { Glyphicon } from 'react-bootstrap';

// import { IndexLink } from 'react-router';
// import Helmet from 'react-helmet';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Navbar, NavBrand, Nav, NavItem, CollapsibleNav } from 'react-bootstrap';
//eslint-disable-line
// import { Glyphicon } from 'react-bootstrap';
// import { Window } from '../../components';
// import DocumentMeta from 'react-document-meta';
// import { isLoaded as isInfoLoaded, load as loadInfo } from 'redux/modules/info';
//eslint-disable-line
// import { InfoBar } from 'components';
// import { SidePanel } from 'components';
// import { DocList } from 'components';


// import connectData from 'helpers/connectData';


var MainMenuLink = _wrapComponent('MainMenuLink')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps, logout: _auth.logout }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MainMenuLink, _Component);

  function MainMenuLink() {
    (0, _classCallCheck3.default)(this, MainMenuLink);
    return (0, _possibleConstructorReturn3.default)(this, (MainMenuLink.__proto__ || (0, _getPrototypeOf2.default)(MainMenuLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(MainMenuLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          setUiProps = _props.setUiProps,
          pushState = _props.pushState,
          to = _props.to,
          action = _props.action,
          color = _props.color;

      var styles = require('./MainMenu.scss');
      var click = function click() {
        setUiProps('mainMenuOpened', false);
        if (to) {
          //window.setTimeout(()=>{
          pushState(null, to);
          //},1000);
        } else {
          action();
        }
      };

      return _react3.default.createElement(
        'div',
        { className: styles.menuItem, style: { background: color } },
        _react3.default.createElement(
          'button',
          { onClick: click },
          this.props.children
        )
      );
    }
  }]);
  return MainMenuLink;
}(_react2.Component), _class2.propTypes = {
  // description: PropTypes.string.isRequired,
  // value: PropTypes.string.isRequired,
  pushState: _react2.PropTypes.func.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired,
  to: _react2.PropTypes.string,
  action: _react2.PropTypes.func,
  color: _react2.PropTypes.string,
  children: _react3.default.PropTypes.oneOfType([_react3.default.PropTypes.arrayOf(_react3.default.PropTypes.node), _react3.default.PropTypes.node])

}, _temp)) || _class));

var Settings = _wrapComponent('Settings')((_dec2 = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, createDialog: _info.createDialog, setUiProps: _info.setUiProps, logout: _auth.logout }, dispatch);
}), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(Settings, _Component2);

  function Settings() {
    (0, _classCallCheck3.default)(this, Settings);
    return (0, _possibleConstructorReturn3.default)(this, (Settings.__proto__ || (0, _getPrototypeOf2.default)(Settings)).apply(this, arguments));
  }

  (0, _createClass3.default)(Settings, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          createDialog = _props2.createDialog,
          info = _props2.info,
          setUiProps = _props2.setUiProps; // eslint-disable-line no-shadow

      var styles = require('./Settings.scss');
      var notationProperty = 'song_notationCZ';
      var notationCZ = info.ui[notationProperty] === false ? false : true;
      var change = function change(value, newValue) {

        if (notationCZ !== newValue) setUiProps(notationProperty, newValue);
      };

      return _react3.default.createElement(
        'div',
        { className: styles.settings },
        _react3.default.createElement(
          'fieldset',
          null,
          _react3.default.createElement(
            'legend',
            null,
            'Zobrazen\xED - notace ',
            _react3.default.createElement(
              'b',
              null,
              'B vs H'
            )
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'div',
              { className: styles.radioItem },
              _react3.default.createElement(
                'label',
                null,
                _react3.default.createElement('input', { type: 'radio', name: 'mygroup1', checked: notationCZ, onChange: function onChange(x) {
                    return change(x, true);
                  } }),
                ' St\u0159edn\xED evropa \\ Central Europe (C-D-E-F-G-A-H)',
                _react3.default.createElement(
                  'div',
                  null,
                  'T\xF3n B znamen\xE1 o p\u016Flt\xF3n  ni\u017E\u0161\xED ne\u017E je t\xF3n H.',
                  _react3.default.createElement('br', null),
                  '(Germany, Central and Eastern Europe, and Scandinavia)'
                )
              )
            ),
            _react3.default.createElement(
              'div',
              { className: styles.radioItem },
              _react3.default.createElement(
                'label',
                null,
                _react3.default.createElement('input', { type: 'radio', name: 'mygroup1', checked: !notationCZ, onChange: function onChange(x) {
                    return change(x, false);
                  } }),
                ' Mezin\xE1rodn\xED \\ International (A-B-C-D-E-F-G)',
                _react3.default.createElement(
                  'div',
                  null,
                  'T\xF3n B znamen\xE1 t\xF3n o jeden ni\u017E\u0161\xED ne\u017E je t\xF3n C.',
                  _react3.default.createElement('br', null),
                  '(United States, Canada, Australia, the United Kingdom, the Republic of Ireland, and the Netherlands, ...)'
                )
              )
            ),
            _react3.default.createElement(
              'div',
              null,
              'v\xEDce: ',
              _react3.default.createElement(
                'a',
                { href: 'https://en.wikipedia.org/wiki/B_(musical_note)', target: '_blank' },
                'https://en.wikipedia.org/wiki/B_(musical_note)'
              )
            )
          )
        )
      );
    }
  }]);
  return Settings;
}(_react2.Component)) || _class3));

var MainMenuSettingsButton = _wrapComponent('MainMenuSettingsButton')((_dec3 = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, createDialog: _info.createDialog, setUiProps: _info.setUiProps, logout: _auth.logout }, dispatch);
}), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(MainMenuSettingsButton, _Component3);

  function MainMenuSettingsButton() {
    (0, _classCallCheck3.default)(this, MainMenuSettingsButton);
    return (0, _possibleConstructorReturn3.default)(this, (MainMenuSettingsButton.__proto__ || (0, _getPrototypeOf2.default)(MainMenuSettingsButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(MainMenuSettingsButton, [{
    key: 'render',
    value: function render() {
      var createDialog = this.props.createDialog; // eslint-disable-line no-shadow

      var styles = require('./MainMenu.scss');
      var click = function click() {
        return createDialog((0, _defineProperty3.default)({ title: 'Nastavení / Settings',
          msg: function msg(closeAction) {
            return _react3.default.createElement(Settings, null);
          },
          okBtnText: 'Yes',
          onClick: function onClick(_) {},
          onNoClick: null }, 'okBtnText', 'Zavřít'));
      };

      return _react3.default.createElement(
        MainMenuLink,
        { action: click, color: '#11AAB7' },
        'Nastaven\xED'
      );
    }
  }]);
  return MainMenuSettingsButton;
}(_react2.Component)) || _class4));

var MainMenuContent = exports.MainMenuContent = _wrapComponent('MainMenuContent')((_temp2 = _class5 = function (_Component4) {
  (0, _inherits3.default)(MainMenuContent, _Component4);

  function MainMenuContent() {
    (0, _classCallCheck3.default)(this, MainMenuContent);
    return (0, _possibleConstructorReturn3.default)(this, (MainMenuContent.__proto__ || (0, _getPrototypeOf2.default)(MainMenuContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MainMenuContent, [{
    key: 'render',
    value: function render() {
      var styles = require('./MainMenu.scss');

      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          MainMenuLink,
          { to: '/create/song', color: '#B91005' },
          'P\u0159idat p\xEDse\u0148'
        ),
        _react3.default.createElement(
          MainMenuLink,
          { to: '/playlists', color: '#337AB7' },
          'Ve\u0159ejn\xE9 playlisty'
        ),
        _react3.default.createElement(MainMenuSettingsButton, null)
      );
    }
  }]);
  return MainMenuContent;
}(_react2.Component), _class5.propTypes = {
  // description: PropTypes.string.isRequired,
  // value: PropTypes.string.isRequired,
  // format: PropTypes.string
}, _temp2));

var MainMenu = _wrapComponent('MainMenu')((_dec4 = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps }, dispatch);
}), _dec4(_class6 = (_temp3 = _class7 = function (_Component5) {
  (0, _inherits3.default)(MainMenu, _Component5);

  function MainMenu() {
    (0, _classCallCheck3.default)(this, MainMenu);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (MainMenu.__proto__ || (0, _getPrototypeOf2.default)(MainMenu)).call(this));

    _this5.handleLogout = function (event) {
      event.preventDefault();
      _this5.props.logout();
    };

    _this5.state = {
      yy: false
    };
    return _this5;
  }

  (0, _createClass3.default)(MainMenu, [{
    key: 'render',


    // changeOpen = () => {
    //   this.setState({ isOpened: !this.state.isOpened });
    // }
    value: function render() {
      var styles = require('./MainMenu.scss');
      var _props3 = this.props,
          info = _props3.info,
          setUiProps = _props3.setUiProps; // eslint-disable-line no-shadow

      var _props$authState = this.props.authState,
          user = _props$authState.user,
          loggingIn = _props$authState.loggingIn,
          loginError = _props$authState.loginError; // eslint-disable-line

      var ui = info.ui;

      var isOpened = ui.mainMenuOpened;
      return _react3.default.createElement(
        'div',
        { className: 'static-modal noPrint' },
        _react3.default.createElement(
          _reactBootstrap.Modal,
          { bsSize: 'large', show: isOpened, onHide: function onHide() {} },
          _react3.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react3.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              'Menu'
            )
          ),
          _react3.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react3.default.createElement(MainMenuContent, null),
            this.props.children
          ),
          _react3.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react3.default.createElement(
              _reactBootstrap.Button,
              { bsStyle: 'primary', onClick: function onClick() {
                  return setUiProps('mainMenuOpened', !isOpened);
                } },
              'Cancel'
            )
          )
        )
      );
    }
  }]);
  return MainMenu;
}(_react2.Component), _class7.propTypes = {
  children: _react3.default.PropTypes.oneOfType([_react3.default.PropTypes.arrayOf(_react3.default.PropTypes.node), _react3.default.PropTypes.node]),
  authState: _react2.PropTypes.object,
  logout: _react2.PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired,
  info: _react2.PropTypes.object
}, _temp3)) || _class6));

exports.default = MainMenu;


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainMenu/MainMenu.js
// module id = 1211
// module chunks = 0